<template>
	<div class="supplier-wallet">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">Credit Cancel</h1>
				<div class="page-header-right text-right ml-a">
				</div>
			</div>
			<div class="page-content">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-lg-6 col-md-6 col-sm-12">
							<div class="input-group mb-3">
								<div class="input-group-prepend">
									<button
										class="btn btn-outline-secondary dropdown-toggle"
										type="button"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										{{ selectedKeywordTypeLabel }}
									</button>
									<div class="dropdown-menu">
										<a class="dropdown-item" @click="assignKeyType('order_id')">Order ID</a>
										<a class="dropdown-item" @click="assignKeyType('history_id')">History ID</a>
									</div>
								</div>
								<!-- Search By -->
								<input
									type="text"
									v-model="keyword"
									@input="onKeywordChange"
									class="form-control"
									:placeholder="`Search by ${selectedKeywordTypeLabel}`"
								/>
							</div>
						</div>
					</div>
				</div>

                <!-- Main Table -->
                <div class="card card-body border-0">
                    <div class="wallet-history-table table-responsive">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th width="5%">{{ $t('No') }}.</th>
                                    <th width="10%">{{ $t('Order Id') }}</th>
                                    <th width="30%">{{ $t('Description') }}</th>
                                    <th width="20%">{{ $t('Value') }}</th>
                                    <th width="12%">{{ $t('Status') }}</th>
                                    <th>{{ $t('Type') }}</th>
                                    <th width="30%">{{ $t('Date') }}</th>
                                    <th width="5%">{{ $t('Action') }}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template
                                    v-for="(act, index) in histories">
                                    <tr
                                        :class="{ 'highlighted': history && history.id === act.id }"
                                        :key="`${index}-1`"
									>
                                        <!-- Index -->
                                        <td class="text-right">{{ index + 1 }}.</td>

                                        <!-- Order Id -->
                                        <td>
                                            <span class="text-bold text-primary" v-if="act && act.order_id !== '' && act.order_id !== null">
                                                #{{ act.order_id }}
                                            </span>
                                            <span v-else>-</span>
                                        </td>

                                        <!-- Description -->
                                        <td>
                                            <span v-if="act.description && act.description !== ''">
                                                {{ act.description }}
                                            </span>
                                            <span v-if="act.description === ''">-</span>
                                        </td>

                                        <!-- Value -->
                                        <td class="text-right">
                                            <mutation-value :data="act" :key="act.id" />
                                        </td>

                                        <!-- Status -->
                                        <td class="text-center">
                                            <mark :class="`order-status status-${act.status}`"><span>{{ act.status }}</span></mark>
                                        </td>

                                        <!-- Type -->
                                        <td class="text-left">
                                            <span>{{ getTypeLabel(act.type) }}</span>
                                        </td>

                                        <!-- Date -->
                                        <td class="text-center">
                                            <span>{{ formatDate(act.created_at) }}</span>
                                        </td>

										<td class="d-flex flex-nowrap">
											<i v-if="act.status === 'completed'" class="bi bi-x-circle-fill text-danger action-icon" v-tooltip="'Cancel Credit'" @click="showConfirmModal(act)"></i>
											<i v-else class="bi bi-x-circle-fill text-muted action-icon"></i>
										</td>

                                        <!-- Actions -->
                                        <td class="text-center">
                                            <div class="d-flex align-items-center justify-content-end pr-4">
                                                <wallet-history-metas
                                                    class="mr-3"
                                                    :show-title="false"
                                                    :metas="act.metas"
                                                    v-if="act.metas"
                                                />
                                                <i class="material-icons cur-p" v-tooltip="'Show Details'" v-if="act.type !== 'withdraw'" @click="showDetails(act)">
                                                    <template v-if="history && history.id === act.id">keyboard_arrow_up</template>
                                                    <template v-else>keyboard_arrow_down</template>
                                                </i>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        class="detail-view"
                                        :key="`${index}-2`"
                                        v-if="history && history.id === act.id && history.type !== 'withdraw'">
                                        <td colspan="8">
                                            <template v-if="act.details">
                                                <div
                                                    class="text-center"
                                                    v-if="act.details.length === 0">
                                                    - {{ $t('No Credit Details') }} -
                                                </div>
                                                <!-- Details -->
                                                <div class="p-1" v-else>
                                                    <h6 class="mb-3 text-bold">{{ $t('Credit Details') }}</h6>
                                                    <div class="card card-body p-3">
                                                        <wallet-history-details :details="act.details" />
                                                    </div>
                                                </div>
                                            </template>
                                            <wallet-history-metas :metas="act.metas" v-if="act.metas" />
                                            <div class="is-loading dark" v-if="!act.details || !act.metas"></div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Table Loader -->
                <div
                    class="table-fetch-status"
                    v-if="isFetching">
                    <div class="is-loading large dark m-auto"></div>
                </div>

                <!-- Table Empty -->
                <div
                    class="list-empty border-0"
                    v-if="histories.length === 0 && isFetching === false">
                    <span><i class="material-icons md-48 mr-2">error_outline</i></span>
                    <span v-if="keyword === ''">There is no data.</span>
                    <span v-else>No data was found</span>
                </div>

			</div>
		</div>

		<!-- Modal Cancel Credit -->
		<modal
			class="table-cancel-credit-modal"
			size="medium"
			@close="isConfirmCancelCredit = false"
			v-if="isConfirmCancelCredit">
			<div slot="header">
				<h3>Confirm Cancel Credit</h3>
			</div>
			<div slot="body">
				<div class="text-left">
					Are you sure want to cancel credit <b>{{ this.selectedHistory.description }} ? </b>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isConfirmCancelCredit = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-danger" :class="{'is-loading': isCancelling}" @click="cancelHistory(selectedHistory)">Cancel Credit</button>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import WalletHistoryDetails from '@/components/WalletHistoryDetails.vue';
import WalletHistoryMetas from '@/components/WalletHistoryMetas.vue';
import MutationValue from '@/components/MutationValue.vue';
import Modal from '@/components/Modal.vue';
import {
	duplicateVar,
	getDateRange,
	// getAxiosErrorMessage,
	// formatNumberPlain,
	// sensorEmailAddress,
	toTitleCase,
} from '@/lib/helper';
import walletApi from '@/api/wallet';

const defaultFilterDate = getDateRange();

export default {
	name: 'AdminCreditCancel',
	components: {
		WalletHistoryDetails,
		WalletHistoryMetas,
		MutationValue,
		Modal,
	},
	data() {
		return {
			keyword: '',
			limit: 25,
			page: 1,
			sort_by: 'id',
			sort: 'desc',
			histories: [],
			history: null,
			isFetching: false,
			isAll: false,
			filterDate: defaultFilterDate,
			typeSelected: 'all',
			statusSelected: 'all',
			orderId: '',
			keywordTypes: [
				{
					key: 'order_id',
					label: 'Order ID',
				},
				{
					key: 'history_id',
					label: 'History ID',
				},
			],
			selectedKeyType: 'order_id',
			selectedHistory: null,
			isConfirmCancelCredit: false,
			isCancelling: false,
		};
	},
	methods: {
		resetHistories() {
			this.histories = [];
			this.isAll = false;
			this.page = 1;
		},
		fetchHistories(reset = true, includeDate = true) {
			this.isFetching = true;
			if (reset) {
				this.resetHistories();
			}
			const params = this.getFetchParams(includeDate);
			const callback = (response) => {
				const histories = response.data.data;
				histories.forEach((history) => {
					this.histories.push(history);
				});
				this.page++;
				if (histories.length < this.limit) {
					this.isAll = true;
				}
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
				this.isAll = true;
			};
			walletApi.getHistories(params, callback, errorCallback);
		},
		fetchHistoryById() {
			this.isFetching = true;
			const historyId = this.keyword;

			const callback = (response) => {
				this.resetHistories();
				const historyItem = response.data;
				if (response.error === 0 && historyItem) {
					this.histories = [historyItem];
				} else {
					this.resetHistories();
				}
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.resetHistories();
				this.isFetching = false;
			};

			walletApi.getHistory(historyId, callback, errorCallback);
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				if (this.keyword !== '') {
					if (this.selectedKeyType === 'history_id') {
						self.fetchHistoryById();
					} else {
						self.fetchHistories(true);
					}
				} else {
					this.resetHistories();
				}
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchHistories(false, false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchHistories(true, false);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		getFetchParams(includeDate = true) {
			const dateFormat = 'YYYY-MM-DD';
			// const startDate = dayjs(this.filterDate.start).format(dateFormat);
			const startDate = '2020-01-01';
			const endDate = dayjs(this.filterDate.end).format(dateFormat);
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				type: this.typeSelected,
				status: this.statusSelected,
			};

			const keyword = this.keyword.trim();

			if (keyword && keyword !== '') {
				params.order_id = keyword;
			}

			if (includeDate) {
				params.since = startDate;
				params.until = endDate;
			}

			return params;
		},
		getTypeLabel(type) {
			let label = type ?? '';
			if (type === 'cod_revenue') {
				label = 'COD Revenue';
			} else {
				label = toTitleCase(type.replace(/_/g, ' '));
			}
			return label;
		},
		formatDate(dateString) {
			const format = 'DD-MM-YYYY - HH:mm';
			const timezone = this.user.timezone;
			const formattedDate = this.moment.utc(dateString).tz(timezone).format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		showDetails(history) {
			if (this.history && this.history.id === history.id) {
				this.history = null;
				return;
			}
			this.history = duplicateVar(history);
			if (!history.details) {
				const callback = (response) => {
					const historyItem = response.data;
					this.history = historyItem;
				};
				const errorCallback = () => {};
				walletApi.getHistory(history.id, callback, errorCallback);
			}
		},
		assignKeyType(key) {
			this.selectedKeyType = key;
		},
		showConfirmModal(history) {
			this.selectedHistory = duplicateVar(history);
			this.isConfirmCancelCredit = true;
		},
		cancelHistory() {
			this.isCancelling = true;
			const params = {};
			const hitoryId = this.selectedHistory?.id ?? '';

			const callback = (response) => {
				const history = response?.data;
				if (response?.error === 0 && history) {
					const historyIndex = this.histories.findIndex(curr => curr.id === hitoryId);
					if (historyIndex !== -1) {
						this.histories[historyIndex].status = 'cancelled';
					}
				}

				this.$notify({
					group: 'app',
					title: 'Credit Cancel',
					text: 'Successfully cancelled the credit',
					type: 'success',
				});

				this.isConfirmCancelCredit = false;
				this.selectedHistory = null;
				this.isCancelling = false;
			};
			const errorCallback = () => {
				this.isCancelling = false;
				this.$notify({
					group: 'app',
					title: 'Credit Cancel',
					text: 'Failed to cancel credit',
					type: 'error',
				});
			};
			walletApi.cancelHistoryById(hitoryId, params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		selectedKeywordTypeLabel() {
			let label = '';

			const selectedKeywordType = this.keywordTypes.find(item => item.key === this.selectedKeyType);
			if (selectedKeywordType && selectedKeywordType.label) {
				label = selectedKeywordType.label;
			}

			return label;
		},
	},
	watch: {
	},
	created() {
		// this.fetchHistories();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped>
.action-icon {
	font-size: 20px;
	cursor: pointer;
	margin-left: 0.5rem !important;
	margin-right: 0.5rem !important;
}
</style>
